import { forwardRef } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import NRSecondaryLinkStyles from './NRSecondaryLink.styles';
import clsx from 'clsx';

const useStyles = makeStyles(NRSecondaryLinkStyles);

const NRSecondaryLink = forwardRef((props, ref) => {
  const classes = useStyles();
  const { value, handleOnClick, openNull = true, disabledClick, ...rest } = props;
  return (
    <span
      ref={ref}
      {...rest}
      onClick={!disabledClick ? () => (openNull ? handleOnClick() : value > 0 && handleOnClick()) : undefined}
      className={clsx(classes.styleBase, { [classes.activeLink]: (openNull || value > 0) && !disabledClick })}
    >
      {value}
    </span>
  );
});
export default NRSecondaryLink;
